import { BaseViewModel } from '../../../../../models/base/base-view-model';
import { Injectable } from '@angular/core';

@Injectable()
export class TemplateLocationInfoTextViewModel extends BaseViewModel {}
